<template>
    <div class="comment-card">
        <div class="card-header">
            <div class="user-info">
                <img v-if="avatarUrl" :src="avatarUrl" class="user-avatar-img" alt="avatar" />
                <div v-else class="user-avatar">{{ initials }}</div>
                <div class="user-details">
                    <strong class="user-name">{{ authorName }}</strong>
                    <small class="timestamp">{{ formattedDate }}</small>
                </div>
            </div>
            <div class="actions-right">
                <button class="goto-btn" @click="$emit('goto', comment)" title="Go to">📍</button>
                <button class="resolve-btn" @click="confirmResolve" title="Resolve">✓</button>
            </div>
        </div>

        <div class="card-content">
            <div class="popup-meta">Page {{ comment.page_number }}</div>
            <div class="comment-text">{{ comment.comment }}</div>
            <slot name="preview"></slot>
        </div>
        <div class="add-reply">
            <input v-model="replyText" type="text" class="reply-input" placeholder="Reply..."
                @keyup.enter="submitReply" />
            <button class="send-btn" @click="submitReply"><img :src="sendIcon" alt="send" /></button>
        </div>
        <div class="replies" v-if="localReplies.length">
            <div v-for="r in localReplies" :key="r.id" class="reply">
           
                <div class="card-header">
                    <div class="user-info">
                        <div class="reply-avatar">{{ (r.user?.name || r.user || 'U')[0].toUpperCase() }}</div>
                        <!-- <div v-else class="user-avatar">{{ initials }}</div> -->
                        <div class="user-details">
                            <strong class="user-name">{{ r.user?.name || r.user || 'User' }}</strong>
                            <small class="timestamp">{{ formatDate(r.created_at || r.ts) }}</small>

                        </div>
                    </div>
                </div>
                <div class="card-content">
                    <div class="comment-text">{{ r.reply }}</div>
                </div>


            </div>
        </div>


    </div>

</template>

<script setup>
import { computed, ref, watchEffect } from 'vue'
import Swal from 'sweetalert2'
import sendIcon from '@/assets/img/send.png'
const props = defineProps({
    comment: { type: Object, required: true },
    replies: { type: Array, default: () => [] },
})

const emit = defineEmits(['reply', 'goto', 'resolve'])

const replyText = ref('')
const localReplies = ref([])

watchEffect(() => {
    const list = Array.isArray(props.replies) ? props.replies : (props.comment?.replies || [])
    // newest first (assuming created_at/ts)
    localReplies.value = list.slice().sort((a, b) => new Date(b?.created_at || b?.ts || 0) - new Date(a?.created_at || a?.ts || 0))
})

const authorName = computed(() => props.comment?.user?.name || 'Anonymous')
const formattedDate = computed(() => formatDate(props.comment?.created_at))
const avatarUrl = computed(() => props.comment?.user?.avatar_url || null)
const initials = computed(() => (authorName.value || 'U').slice(0, 1).toUpperCase())

function submitReply() {
    const text = replyText.value.trim()
    if (!text) return
    emit('reply', { text, comment: props.comment })
    replyText.value = ''
}

function formatDate(d) {
    if (!d) return ''
    try { return new Date(d).toLocaleString() } catch { return '' }
}

async function confirmResolve() {
    const res = await Swal.fire({
        title: 'Resolve this comment?',
        text: 'This will mark the comment as resolved and hide it from the list.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, resolve',
        cancelButtonText: 'Cancel'
    })
    if (res.isConfirmed) {
        emit('resolve', { comment: props.comment })
    }
}
</script>

<style scoped></style>
